module.exports = __webpack_public_path__ + "static/media/contract-farming.2275b9dd.svg";